import Immutable from 'immutable';

// constants
import { POST_NEW_TRADE_OFFER, FETCH_POSTED_OFFERS } from '../constants/postedOffersTypes';

// lib
import httpReducer from '../lib/httpReducer';
import { callbackHandler, mergeObject } from '../lib/mapReducerHelpers';

export default function(state = Immutable.Map(), action) {
  switch (action.type) {
    case POST_NEW_TRADE_OFFER: return httpReducer(state, action);
    case FETCH_POSTED_OFFERS: return httpReducer(state, action, callbackHandler(mergeObject));
    default:                   return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/postedOffers.js